import Router from "./pages/shared/router";
import "./css/custom.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

function App() {
    return <Router />;
}

export default App;
